import { BOAT_STATUS } from 'types'
import findPrimaryBoat from './findPrimaryBoat'

function findActivePrimaryBoat(boats) {
  const primaryBoat = findPrimaryBoat(boats)

  return primaryBoat?.boat_status__c === BOAT_STATUS.ACTIVE
    ? primaryBoat
    : undefined
}

export default findActivePrimaryBoat
